import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
    <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
        <table class="data01">
            <thead>
            <tr>
                <th>{{ 'search.Course name' | translate }}</th>
                <th>{{ 'search.Date created' | translate }}</th>
                <th>{{ 'search.Last modified' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="course in vm.list.items">
                <td><a ui-sref="authorized.courses.courses.edit.general({ id: course.id })">{{ course.name }}</a></td>
                <td>{{ vm.MomentService.formatTimeStamp(course.createdAt, 'DD.MM.YYYY') }}</td>
                <td>{{ vm.MomentService.formatTimeStamp(course.updatedAt, 'DD.MM.YYYY') }}</td>
            </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
`
})
export default class {
    constructor ($state, SearchResource, ListFactory, MomentService) {
        this.SearchResource = SearchResource;
        this.list = ListFactory.createWithPagination(SearchResource.getCourses.bind(SearchResource));
        this.list.fetch({ keyword: $state.params.keyword });
        this.MomentService = MomentService;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/search/courses/index.js